export const initialHistoryState: HistoryState = {
  urlToContinueShopping: null,
}

export interface HistoryState {
  urlToContinueShopping: string | null,
}
